export var SwapStatusEnum;
(function (SwapStatusEnum) {
    SwapStatusEnum["DRAFT"] = "draft";
    SwapStatusEnum["BLOCKED"] = "blocked";
    SwapStatusEnum["DEPOSIT_PENDING"] = "deposit_pending";
    SwapStatusEnum["DEPOSIT_CONFIRMED"] = "deposit_confirmed";
    SwapStatusEnum["DEPOSIT_FAILED"] = "deposit_failed";
    SwapStatusEnum["EXCHANGE_IN_PROGRESS"] = "exchange_in_progress";
    SwapStatusEnum["EXCHANGE_COMPLETED"] = "exchange_completed";
    SwapStatusEnum["EXCHANGE_FAILED"] = "exchange_failed";
    SwapStatusEnum["WITHDRAW_IN_PROGRESS"] = "withdraw_in_progress";
    SwapStatusEnum["WITHDRAW_COMPLETED"] = "withdraw_completed";
    SwapStatusEnum["WITHDRAW_FAILED"] = "withdraw_failed";
})(SwapStatusEnum || (SwapStatusEnum = {}));
//# sourceMappingURL=swap-status.enum.js.map